import { Template } from 'cruzo';
import { delay } from 'cruzo/utils';

export function stylesHashToString(styles: { [key: string]: any }) {
  const keys = Object.keys(styles);
  let result = '';
  let i = 0;

  while (i < keys.length) {
    let property = keys[i];
    let value = styles[keys[i]];
    result += `${property}: ${value};`;
    i++;
  }

  return result;
}

export function getParamsForAnim(value: any, params: any) {
  let { speed, type } = params;
  const cls = [];

  speed = speed || 0.5;
  type = type || 'default';

  if (value) {
    cls.push(`container_co_${type}--opened`);
  } else {
    cls.push(`container_co_${type}--closed`);
  }

  let speedCss = '';

  if (speed === 0.5) {
    speedCss = '0_5';
  }

  if (speed === 1.5) {
    speedCss = '1_5';
  }

  cls.push(`container_co_${speedCss}`);
  cls.push(`container_co_${type}`);

  return cls.join(' ');
}

export function openCloseAnim(value: any, params = {}) {
  const cls = [];

  const paramsClass = getParamsForAnim(value, params);

  if (paramsClass) {
    cls.push(paramsClass);
  }

  return cls.join(' ');
}

export function initAnimationElements(animationElements: any, template: Template) {
  const keys = Object.keys(animationElements) as any[];

  let i = 0;

  while (i < keys.length) {
    (async (index) => {
      const key = keys[index];
      const item = animationElements[key];

      await delay(item.delay());
      animationElements[key] = false;
      template.detectChanges();
    })(i);

    i++;
  }
}

export function getRandomArrayIndexes(array: any[], maxLength: number) {
  const indexes = array.map((v, index) => index).sort(() => Math.random() - 0.5);

  if (indexes.length > maxLength) {
    indexes.length = maxLength;
  }

  return indexes;
}

export function daysLeft(date: number) {
  return Math.max(
    0,
    Math.floor((new Date(date).getTime() - new Date().getTime())/1000/60/60/24)
  );
}

export function plural(number: number, translate: any) {
    const {one, two, five} = translate;

    let n = Math.abs(number);
    n %= 100;
    if (n.toString().includes('.')) {
      return two;
    }
    if (n >= 5 && n <= 20) {
      return five;
    }
    n %= 10;
    if (n === 1) {
      return one;
    }
    if (n >= 2 && n <= 4) {
      return two;
    }
    return five;
}

export function humanLikeTime(ms: number, trs: any) {
    const delta = Math.round((+new Date - ms) / 1000);

    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;
    const week = day * 7;

    if (delta < 30) {
      return 'только что';
    } else if (delta < minute) {
      return delta + ` ${plural(delta, trs.ru.seconds)} назад`;
    } else if (delta < 2 * minute) {
      return `минуту назад`
    } else if (delta < hour) {
      const minutes = Math.floor(delta / minute);

      return minutes + ` ${plural(minutes, trs.ru.minutes)} назад`;
    } else if (Math.floor(delta / hour) == 1) {
      return `1 час назад`
    } else if (delta < day) {
      const hours = Math.floor(delta / hour);

      return hours + ` ${plural(hours, trs.ru.hours)} назад`;
    } else if (delta < day * 2) {
      return `вчера`;
    } else {
      return new Date(ms).toLocaleString();
    }
}

export const capitalizeFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export function toBufferSource(bytes: Uint8Array): BufferSource {
  return Uint8Array.from(bytes);
}